import { render, staticRenderFns } from "./draftWasiat.vue?vue&type=template&id=1f7a55d3&"
import script from "./draftWasiat.vue?vue&type=script&lang=js&"
export * from "./draftWasiat.vue?vue&type=script&lang=js&"
import style0 from "./draftWasiat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports